import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';
import FormStyles from 'styles/mixins/Form.styles';

const StyledEntitiesBulkDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: clamp(0px, ${props => props.theme.layout(452)}, 86vw);
    max-width: clamp(0px, ${props => props.theme.layout(452)}, 86vw);
  }

  ${FormStyles}
  ${ComponentStyles}
`;

StyledEntitiesBulkDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledEntitiesBulkDialog;
